
<form [formGroup]="form">


  <mat-form-field class="observation card-inline">
    <mat-label>Observaciones</mat-label>
    <input formControlName="Observation" type="text" matInput />
  </mat-form-field>

  <mat-form-field class="observation card-inline">
    <mat-label>Observaciones predefinidas</mat-label>
    <input formControlName="BudgetText" type="text" matInput />
  </mat-form-field>

</form>
